<template>
  <div class="wrap">
    <div class="header">
      <div class="header-price"><span>¥</span>{{ totalValue }}</div>
    </div>
    <div class="content">
      <HbBenefit
        v-for="item in categoryList"
        :key="item.id"
        :item="item"
        :allBenefitList="benefitList"
      />
      <div class="footer">
        权益由橡树提供，服务热线：<span>400-150-9669</span>
      </div>
    </div>
  </div>
</template>

<script>
import {
  defineComponent,
  onMounted,
  ref,
  computed,
} from "@vue/composition-api";
import Vue from "vue";
import { useStore, useRoute } from "@/components/use/base";
import useMoreCard from "@/use/useMoreCard";
import HbBenefit from "../component/common/HbBenefit.vue";
import { getNamespaceBenefit } from "@/apis/home";
import { jsonSafeParse } from "@/utils";

const vm = Vue.prototype;

export default defineComponent({
  components: {
    HbBenefit,
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const { initMoreCardForVisitor, categoryList } = useMoreCard();
    const benefitList = ref([]);

    const namespace = computed(() => store.state.namespace);
    const totalValue = computed(() => Number(route.query.total_value || 0));

    const initPageInfo = async () => {
      const packageMap = jsonSafeParse(vm.$getConfigValue("WC_CARD_MAP"));
      const page = packageMap[namespace.value];
      initMoreCardForVisitor(page);
      const { data: benefitData } = await getNamespaceBenefit({
        package: page.toUpperCase(),
        namespace: namespace.value,
      });
      benefitList.value = benefitData.map((item) => item.benefit_type);
    };

    onMounted(async () => {
      initPageInfo();
    });

    return {
      categoryList,
      benefitList,
      totalValue,
    };
  },
});
</script>

<style scoped lang="less">
.wrap {
  background: #eeeff3;
}

.header {
  width: 100%;
  height: 364px;
  background: url("https://common-h5-dev.xiangshuheika.com/static/upload/20251209c4b9509df957d.png")
    no-repeat center/100%;
  position: relative;

  .header-price {
    position: absolute;
    top: 134px;
    left: 50%;
    transform: translateX(-50%);
    font-family: LiGothicMed;
    font-size: 50px;
    color: #ff561a;
    line-height: 54px;
    text-align: center;
    font-style: normal;
    span {
      font-size: 24px;
    }
  }
}

.content {
  background: #ffffff;
  border-radius: 8px 8px 0 0;
  overflow: hidden;
}

.footer {
  margin: 40px auto;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #333333;
  line-height: 17px;
  text-align: center;
  font-style: normal;
  > span {
    color: #fc4b21;
  }
}
</style>